@switch (webauthPopupActualPage) {
  @case ('CONNECTION_EXTERNAL_BANK_OK') {
    <app-connection-to-external-bank-ok
      [displayCrossDeviceCopy]="isServerOutcome"
    ></app-connection-to-external-bank-ok>
  }
  @case ('CONNECTION_EXTERNAL_BANK_KO') {
    <app-connection-to-external-bank-ko
      [displayCrossDeviceCopy]="isServerOutcome"
    ></app-connection-to-external-bank-ko>
  }
  @case (undefined) {
    <div class="flex h-svh">
      <img class="m-auto" src="../../../../../assets/svg/loader.svg" alt="loader" />
    </div>
  }
}
